interface FixedHeaderProps {
  progress: number;
  sectionLabel: string;
}

export default function FixedHeader({ progress, sectionLabel }: FixedHeaderProps) {
  return (
    <div className="sticky top-0 z-10 bg-cream border-b border-border-color">
      <div className="px-6 pt-5 pb-3">
        <div className="flex items-center gap-3 mb-2">
          <div className="flex-1 h-2 bg-border-color rounded-full overflow-hidden">
            <div
              className="h-full bg-coral rounded-full transition-all duration-500 ease-out"
              style={{ width: `${progress}%` }}
            />
          </div>
          <span className="text-xs font-semibold text-text-secondary whitespace-nowrap min-w-[36px] text-right">
            {progress}%
          </span>
        </div>
        {sectionLabel && (
          <p className="text-xs text-text-secondary font-medium tracking-wide">
            {sectionLabel}
          </p>
        )}
      </div>
    </div>
  );
}